module.exports = __webpack_public_path__ + "img/tsuka.ee68c277.svg";